import React, { createContext, useReducer } from 'react';
import { AdvancedBookingWidget, AdvancedBookingWidgetAction } from '../typings';

export const AdvancedBookingContext = createContext<AdvancedBookingWidget | null>(null);
export const AdvancedBookingDispatchContext = createContext<React.Dispatch<AdvancedBookingWidgetAction> | null>(null);

export function AdvancedBookingProvider({
  children,
  initialState,
}: {
  children: React.ReactNode;
  initialState: AdvancedBookingWidget;
}) {
  const [bookingWidget, dispatch] = useReducer(advancedBookingWidgetReducer, initialState);

  return (
    <AdvancedBookingContext.Provider value={bookingWidget}>
      <AdvancedBookingDispatchContext.Provider value={dispatch}>{children}</AdvancedBookingDispatchContext.Provider>
    </AdvancedBookingContext.Provider>
  );
}

function advancedBookingWidgetReducer(bookingWidget: AdvancedBookingWidget, action: AdvancedBookingWidgetAction) {
  let allHotelData = bookingWidget.allHotelData;
  let allflightData = bookingWidget.allflightData;
  switch (action.type) {
    case 'updateTab': {
      const activeTab = action.activeTab;
      return { ...bookingWidget, activeTab, isLoading: false };

    }
    case 'updateFilters': {
      const filters = action.data;
      const isLoading = Object.keys(filters).length !== 0;
      return { ...bookingWidget, filters, isLoading, isNoHotelData:false, isNoFlightData:false };

    }
    case 'loading': {
      return { ...bookingWidget, isLoading: action.loading };
    }
    case 'searchFlight': {
      allflightData = action.data?.listings ?? [];
      const isLoading = action.loading;
      const flightData = allflightData.slice(0, 3);
      return { ...bookingWidget, flightData, allflightData, isLoading, isNoFlightData: allflightData.length === 0 };
    }
    case 'searchHotel': {
      allHotelData = action.data ?? [];
      const isLoading = action.loading;
      const hotelData = allHotelData.slice(0, 3);
      return { ...bookingWidget, hotelData, allHotelData, isLoading, isNoHotelData: allHotelData.length === 0 };
    }
    case 'seeMore': {
      const type = action.data;
      if(type === 'hotel'){
        const hotelData = allHotelData.slice(0, bookingWidget.hotelData.length + 3);
        return { ...bookingWidget, hotelData };
      }else {
        const flightData = allflightData.slice(0, bookingWidget.flightData.length + 3);
        return { ...bookingWidget, flightData };
      }
    }
    case 'setAllData': {
      const type = action.data;
      if(type === 'hotel'){
        const hotelData = allHotelData;
        return { ...bookingWidget, hotelData };
      }else {
        const flightData = allflightData;
        return { ...bookingWidget, flightData };
      }
    }
    default: {
      throw new Error('Unknown action: ' + action.type);
    }
  }
}
